import React from 'react'
import { Link } from 'react-router-dom'
import Blog_1 from '../../../assets/images/blog/blog-three-1.jpg'
import Blog_2 from '../../../assets/images/blog/blog-three-calendar.svg'
import Blog_3 from '../../../assets/images/blog/blog-three-comment.svg'
import Blog_4 from '../../../assets/images/blog/blog-three-2.jpg'
import Blog_5 from '../../../assets/images/blog/blog-three-calendar.svg'
import Blog_6 from '../../../assets/images/blog/blog-three-comment.svg'

const Blog = () => {
    return (
        <>
            <div className="blog-section-three">
                <div className="container">
                    <div className="row gutter-y-40">
                        <div className="col-xl-4">
                            <div
                                className="blog-heading-box animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="heading-box">
                                    <h2 className="heading-title">Journal from Uniqo</h2>
                                </div>
                                <p>
                                    We believe that the human dimensions essential to start any
                                    successful project.
                                </p>
                                <Link to="/Blog" className="btn btn-light btn-theme">
                                    View More <span>+</span>
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <div
                                className="blog-box-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="blog-image-three">
                                    <img src={Blog_1} alt="blog-image" />
                                    <ul className="blog-tag-three">
                                        <li>
                                            <Link to="/BlogDetails">Business</Link>
                                        </li>
                                    </ul>
                                </div>
                                <ul className="blog-meta-three">
                                    <li>
                                        <img
                                            src={Blog_2}
                                            alt="icon"
                                        />
                                        <Link to="/BlogDetails">18 November 2024 </Link>
                                    </li>
                                    <li>
                                        <img src={Blog_3} alt="icon" />
                                        <Link to="/BlogDetails">25 Comments </Link>
                                    </li>
                                </ul>
                                <h4>
                                    <Link to="/BlogDetails">
                                        Understanding behavioral biases and making to the rational way
                                    </Link>
                                </h4>
                                <Link to="/BlogDetails" className="btn btn-light btn-theme">
                                    Read More <span>+</span>
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <div
                                className="blog-box-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="blog-image-three">
                                    <img src={Blog_4} alt="blog-image" />
                                    <ul className="blog-tag-three">
                                        <li>
                                            <Link to="/BlogDetails">Marketing</Link>
                                        </li>
                                    </ul>
                                </div>
                                <ul className="blog-meta-three">
                                    <li>
                                        <img
                                            src={Blog_5}
                                            alt="icon"
                                        />
                                        <Link to="/BlogDetails">18 November 2024 </Link>
                                    </li>
                                    <li>
                                        <img src={Blog_6} alt="icon" />
                                        <Link to="/BlogDetails">25 Comments </Link>
                                    </li>
                                </ul>
                                <h4>
                                    <Link to="/BlogDetails">
                                        How to create your purpose-filled career comfortabl
                                    </Link>
                                </h4>
                                <Link to="/BlogDetails" className="btn btn-light btn-theme" >
                                    Read More <span> +</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Blog
